import { Box } from "@mui/material";
import React from "react";
import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import { useSelector } from "react-redux";
import auth from "../Layout/util/auth";
import cookie from "js-cookie";
import { enquireNowGTMCTAClick } from "../../util/gtmutil";

const useStyles = makeStyles((theme) => ({
  appbg__section: {
    background: "rgb(250,172,168)",
    background:
      "linear-gradient(90deg, rgba(250,172,168,1) 28%, rgba(221,214,243,1) 70%)",
    margin: "auto",
    borderRadius: "45px",
    padding: "70px",
    color: "#0C091B",
    height: "507px",

    "@media (max-width:1024px)": {
      height: "auto",
      padding: "40px 30px",
    },
    "@media (max-width:767px)": {
      height: "auto",
      padding: "40px 30px",
      textAlign: "center",
    },
    "& h2": {
      fontSize: "60px",
      lineHeight: "60px",
      fontWeight: "bold",

      "@media (max-width:1024px)": {
        fontSize: "40px",
        lineHeight: "43px",
        textAlign: "center",
      },
      "@media (max-width:767px)": {
        fontSize: "25px",
        lineHeight: "30px",
        textAlign: "center",
      },
    },
    "& p": {
      fontSize: "24px",
      margin: "30px 0",
      fontWeight: "500",
      "@media (max-width:767px)": {
        fontSize: "14px",
        margin: "15px 0",
        textAlign: "center",
      },
    },
  },
  fan__mobileApp: {
    position: "absolute",

    right: "60px",
    top: "-73px",

    "@media (max-width:1024px)": {
      position: "inherit",
    },
    "@media (max-width:767px)": {
      position: "inherit",
      "& img": {
        height: "auto !important",
        marginTop: "20px",
      },
    },
  },
  fanApp__iconSection: {
    position: "relative",
    width: "1410px",
    margin: "auto",

    "@media (max-width:1500px)": {
      width: "100%",
      padding: "0 20px",
    },
    "@media (max-width:1024px)": {
      width: "100%",
      padding: "0 20px",
    },
    "& .androidIcon": {
      position: "absolute",
      left: "-65px",
      top: "-10px",
      "@media (max-width:767px)": {
        top: "-31px",
        left: "-7px",
        width: "90px",
      },
    },
    "& .iosIcon": {
      position: "absolute",
      right: "-34px",
      top: "48%",
      width: "89px",
      "@media (max-width:767px)": {
        width: "75px",
        right: "-10px",
        top: "35%",
      },
    },
  },
  app_Section: {
    padding: "54px 0px 70px  0",
    "@media (max-width:767px)": {
      padding: "30px 0",
    },
  },
}));

function App() {
  const classes = useStyles();
  const r = auth();
  const { userData } = useSelector((state) => state.user);

  return (
    <>
      <section className={classes.app_Section}>
        <Container maxWidth="xl">
          <div className={classes.fanApp__iconSection}>
            <div className="androidIcon">
              <img src={"/images/newHome/android.png"} alt="android image" />
            </div>
            {/* <div className="iosIcon">
              <img src={"/images/newHome/iosicon.svg"} />
            </div> */}
            <div className={classes.appbg__section}>
              <Box className={classes.fan__workSection} sx={{ width: "100%" }}>
                <Grid
                  direction="row"
                  alignItems="center"
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  <Grid item md={6}>
                    <Typography variant="h2">
                      Stay updated with your investments & new drops
                    </Typography>
                    <p>Join the music revolution</p>
                    <img
                      src="/images/newHome/app1.svg"
                      style={{ width: "200px", cursor: "pointer" }}
                      alt="app image"
                      onClick={() => {
                        enquireNowGTMCTAClick(
                          r,
                          "ctaClicks",
                          "loggedIn",
                          "Guest",
                          "Download FanTiger App",
                          userData?.mobile,
                          userData?.email,
                          cookie.get("_gid")
                        );
                        window.open(
                          "https://play.google.com/store/apps/details?id=com.fantiger",
                          "_blank"
                        );
                      }}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <div className={classes.fan__mobileApp}>
                      <img
                        src={"/images/home/phoneuimockup.png"}
                        style={{ height: "600px", width: "600px" }}
                        alt="app image"
                      />
                    </div>
                  </Grid>
                </Grid>
              </Box>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}

export default App;
